import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Asterisk } from 'lucide-react';
import { BRAND } from '../mock';

export default function Landing() {
  const nav = useNavigate();
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      <img src={BRAND.heroImage} alt="Happy cat" className="absolute inset-0 h-full w-full object-cover" />
      <div className="hero-overlay absolute inset-0" />

      {/* brand pill */}
      <div className="absolute left-5 top-5 z-10 animate-fade-up">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/90 py-1.5 pl-1.5 pr-4 text-sm font-extrabold tracking-tight text-[hsl(var(--coral))] backdrop-blur">
          <img src="/purrflect-icon.png" alt="Purrflect" className="h-6 w-6 rounded-full object-cover" />
          {BRAND.name}
        </span>
      </div>

      {/* bottom content */}
      <div className="absolute inset-x-0 bottom-0 z-10 px-5 pb-8 sm:px-8">
        <div className="mx-auto max-w-xl animate-fade-up">
          <h1 className="text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl">
            {BRAND.tagline_top}<br />{BRAND.tagline_rest}
          </h1>
          <p className="mt-4 max-w-md text-[15px] leading-relaxed text-white/90">{BRAND.subtitle}</p>
          <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/80">
            Free to try · Pro only $9/month · Cancel anytime
          </p>

          <button
            onClick={() => nav('/auth', { state: { mode: 'signup' } })}
            className="coral-btn mt-5 w-full rounded-2xl py-4 text-base font-bold text-white"
          >
            Get Started
          </button>
          <button
            onClick={() => nav('/auth', { state: { mode: 'signin' } })}
            className="mt-3 w-full rounded-2xl py-3 text-sm font-semibold text-white/95 transition-colors hover:text-white"
          >
            I already have an account
          </button>

          <div className="mt-4 flex justify-center">
            <button
              onClick={() => nav('/vets')}
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-white/85 underline underline-offset-4 transition-colors hover:text-white"
            >
              <Asterisk className="h-4 w-4" /> For veterinary clinics
            </button>
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] text-white/70">
            <span>Happy Big Dogs · Oregon</span>
            <span>·</span>
            <a href="/terms" className="underline underline-offset-2 hover:text-white">Terms</a>
            <a href="/privacy" className="underline underline-offset-2 hover:text-white">Privacy</a>
            <a href="/disclaimer" className="underline underline-offset-2 hover:text-white">Disclaimer</a>
            <a href="/sms-optin" className="underline underline-offset-2 hover:text-white" data-testid="footer-sms-optin">SMS Alerts</a>
          </div>
        </div>
      </div>
    </div>
  );
}
